module.exports = __webpack_public_path__ + "static/media/fa-regular-400.6bf2d6c8.ttf";